// 注册中心名称
const apiName = process.env.BUILD_ENV === 'dev' ? 'ec-pc-api' : 'ec-pc-api'
const common = {
  upload: {
    type: 'upload', // 自定义类型，实际为post
    url: '/qu-live-manage/authority/uploadFile'
  },
  batchUpload: {
    type: 'batchUpload', // 自定义类型，实际为post
    url: '/qu-live-manage/authority/multiUploadFile'  
  },
  uploadFile: {
    type: 'upload', // 自定义类型，实际为post
    url: `/qu-platform-excel-api/excel/import/task`
  },
  uploadMedia: {
    type: 'upload', // 自定义类型，实际为post
    url: `ec-file-api/file/upload/media`
  },
  uploadMediaBatchUpload: {
    type: 'batchUpload', // 自定义类型，实际为post
    url: `ec-file-api/file/upload/media`
  },
  // 办公平台导出接口
  exportExcel: {
    type: 'post',
    url: `/qu-platform-excel-api/excel/export/task`
  },
  //子定义列导出
  customExportExcel: {
    url: `/qu-platform-excel-api/excel/customColumn/export/task`,
    type: 'post'
  },
  //基础信息表分页列表导出
  boomExport: {
    url: `/ec-pc-api/boom/export/listPage`,
    type: 'post'
  },
  //通用报表分页查询
  reportSearch: {
    url: `/ec-pc-api/common/report/search`,
    type: 'post'
  },
  //通用索引信息查询
  reportGetIndexInfo: {
    url: `/ec-pc-api/common/report/getIndexInfo`,
    type: 'post'
  },
  //查询列头
  columns: {
    url: `/ec-pc-api/customize/columns`,
    type: 'get'
  },
  //自定义列
  mergeColumns: {
    url: `/ec-pc-api/customize/merge/columns`,
    type: 'post'
  },
  //取数接口
  reportsData: {
    url: `/ec-pc-api/custom/reports/data`,
    type: 'post',
  },
  // 表头索引分组取数
  reportsDataGroup: {
    url: `/ec-pc-api/custom/reports/data/group`,
    type: 'post',
  },
  // 页面数据刷新时间
  refreshTime: {
    url: `/ec-pc-api/common/report/data/refreshTime`,
    type: 'get',
  },
  // 办公平台获取模板下载链接
  getTemplate: {
    url: `/qu-platform-excel-api/excel/cfg/getTemplate`,
    type: 'get',
  },
  // 办公平台导入列表
  excelTaskList: {
    url: `/qu-platform-excel-api/excel/task/list`,
    type: 'post',
  },
  // 查询异步任务执行情况
  reportTaskInfo: {
    url: `/ec-pc-api/common/report/task/Info`,
    type: 'get',
  },
  // 数据刷新时间查询
  getRefreshTime: {
    url: `/ec-pc-api/common/report/data/refreshTime`,
    type: 'get',
  },
};

export default common;
